module.exports = __webpack_public_path__ + "static/media/header-background.694360ff.svg";